import React from 'react'
import { IMapComponent } from '../utility/types'

const lazyLoad = (resolver: any, name = 'default') => {
  return React.lazy(async () => {
    const resolved = await resolver()
    return { default: resolved[name] }
  })
}

const RouteWisePerformance = lazyLoad(
  () => import('../modules/Routes'),
  'RouteWisePerformance'
)

const MultiModalTransporter = lazyLoad(
  () => import('../modules/Transporters'),
  'MultiModalTransporter'
)
const MultiModalRoute = lazyLoad(
  () => import('../modules/Routes'),
  'MultiModalRoute'
)
const MultiModalTableList = lazyLoad(
  () => import('../components/Table/MutliModalTable'),
  'MultiModalTableList'
)
const RouteDetails = lazyLoad(() => import('../modules/Routes'), 'RouteDetails')

const RouteWiseDetails = lazyLoad(
  () => import('../modules/Routes'),
  'RouteWiseDetails'
)

const TransportersPerformance = lazyLoad(
  () => import('../modules/Transporters'),
  'TransportersPerformance'
)

const TransportersDetailsCard = lazyLoad(
  () => import('../modules/Transporters'),
  'TransportersDetailsCard'
)

const TransporterDetails = lazyLoad(
  () => import('../modules/Transporters'),
  'TransporterDetails'
)

const eta = lazyLoad(() => import('../modules/eta'), 'ETA')

const Timeline = lazyLoad(() => import('../modules/eta'), 'ETATimeLine')

const TripTable = lazyLoad(() => import('@fareye/common'), 'TripTable')
const TripTableETA = lazyLoad(() => import('../modules/eta'), 'TripTableETA')

const MultiModelListing = lazyLoad(
  () => import('../modules/multi-model'),
  'MultiModelListing'
)
const ContainerListTable = lazyLoad(
  () => import('../components/Table/ContainerListTable'),
  'ContainerListTable'
)
const MultiModelTimeLine = lazyLoad(
  () => import('../modules/multi-model'),
  'MultiModelTimeLine'
)
const TripTableMultiModel = lazyLoad(
  () => import('../modules/multi-model'),
  'TripTableMultiModel'
)
const ShipmentTimeLine = lazyLoad(
  () => import('../components/Timeline'),
  'ShipmentTimeLine'
)
const MultiShipmentTimeline = lazyLoad(
  () => import('../components/Timeline'),
  'MultiShipmentTimeline'
)
const PackageTimeLine = lazyLoad(
  () => import('../components/Timeline'),
  'PackageTimeLine'
)
const MultiModalRouteDetails = lazyLoad(
  () => import('../modules/Routes'),
  'MultiModalRouteDetails'
)
const ParcelRouteDetails = lazyLoad(
  () => import('../modules/Routes'),
  'ParcelRouteDetails'
)
const ParcelRoute = lazyLoad(() => import('../modules/Routes'), 'ParcelRoute')
const MultiModalTransporterDetails = lazyLoad(
  () => import('../modules/Transporters'),
  'MultiModalTransporterDetails'
)
const CarrierDetailsCard = lazyLoad(
  () => import('../modules/Transporters'),
  'CarrierDetailsCard'
)
const ParcelCarrierPerformance = lazyLoad(
  () => import('../modules/Transporters'),
  'ParcelCarrierPerformance'
)
const ParcelCarrierDetails = lazyLoad(
  () => import('../modules/Transporters'),
  'ParcelCarrierDetails'
)
const TransportersDetailsOcean = lazyLoad(
  () => import('../modules/Transporters'),
  'TransportersDetailsOcean'
)
const TripTableParcel = lazyLoad(
  () => import('../modules/parcel/index'),
  'TripTableParcel'
)

const ParcelDetailTable = lazyLoad(
  () => import('../components/Table/ParcelDetailTable'),
  'ParcelDetailTable'
)

const ParcelTimeline = lazyLoad(
  () => import('../components/Timeline'),
  'ParcelTimeline'
)
const ContainerStatusTable = lazyLoad(
  () => import('../modules/container-status-dashboard'),
  'ContainerStatusTable'
)
export const mapping: IMapComponent = {
  RouteWisePerformance,
  TransportersPerformance,
  RouteDetails,
  TripTable,
  RouteWiseDetails,
  TransportersDetailsCard,
  TransporterDetails,
  TripTableETA,
  eta,
  Timeline,
  MultiModelPackageTimeLine: PackageTimeLine,
  ShipmentTimeLine,
  MultiShipmentTimeline,
  MultiModelListing,
  TripTableMultiModel,
  MultiModalRoute,
  MultiModalTransporter,
  MultiModalRouteDetails,
  MultiModalTableList,
  MultiModalTransporterDetails,
  TransportersDetailsOcean,
  ContainerListTable,
  TripTableParcel,
  CarrierDetailsCard,
  ParcelCarrierPerformance,
  ParcelCarrierDetails,
  ParcelDetailTable,
  ParcelRouteDetails,
  ParcelRoute,
  ParcelTimeline,
  ContainerStatusTable
}
